import React, { useEffect, useRef } from 'react';

import styles from './onboarding.module.css';
import { CHECKLIST_ITEMS } from './onboardingSteps';
import { getLocale } from './locales';
import { useOnboarding } from './onboardingContext';

// Чек-лист первых шагов: короткий путь до первой заявки в банки.
// Висит в углу, прячется по кнопке и сам исчезает, когда всё сделано.

const OnboardingChecklist = () => {
  const { checklistDone, checklistHidden, hideChecklist, allChecklistDone, tourRunning } = useOnboarding();
  const locale = getLocale();

  // Всё выполнено — убираем сами, но не в ту же секунду: пусть человек
  // увидит, что последний пункт закрылся.
  const hideTimer = useRef(null);

  useEffect(() => {
    if (!allChecklistDone || checklistHidden) return undefined;

    hideTimer.current = setTimeout(() => hideChecklist('completed'), 2000);
    return () => clearTimeout(hideTimer.current);
  }, [allChecklistDone, checklistHidden, hideChecklist]);

  // Во время тура не загораживаем экран.
  if (checklistHidden || tourRunning) return null;

  const done = checklistDone.length;
  const total = CHECKLIST_ITEMS.length;
  const percent = Math.round((done / total) * 100);

  return (
    <aside className={styles.checklist} aria-label={locale.checklist.title} data-testid="onboarding-checklist">
      <div className={styles.checklistHead}>
        <h2 className={styles.checklistTitle}>{locale.checklist.title}</h2>
        <button type="button" className={styles.skip} onClick={() => hideChecklist('manual')}>
          {locale.checklist.hide}
        </button>
      </div>

      <p className={styles.checklistSubtitle}>{allChecklistDone ? locale.checklist.done : locale.checklist.subtitle}</p>

      <div
        className={styles.progressTrack}
        role="progressbar"
        aria-valuenow={done}
        aria-valuemin={0}
        aria-valuemax={total}
      >
        <div className={styles.progressBar} style={{ width: `${percent}%` }} />
      </div>

      <ul className={styles.checklistItems}>
        {CHECKLIST_ITEMS.map((item) => {
          const isDone = checklistDone.includes(item);

          return (
            <li key={item} className={`${styles.checklistItem} ${isDone ? styles.checklistItemDone : ''}`}>
              <span className={`${styles.mark} ${isDone ? styles.markDone : ''}`} aria-hidden="true">
                {isDone ? '✓' : ''}
              </span>
              {locale.checklist.items[item]}
            </li>
          );
        })}
      </ul>
    </aside>
  );
};

export default OnboardingChecklist;
